import { ChevronRight, FileText } from "lucide-react";
import { Link } from "react-router";
import { SectionHeading } from "@zylarity/ui";
import { CompassMark } from "./compass-mark.js";

const homeCapabilities = [
  {
    title: "Talent Assessments",
    copy: "Explore technical experience for a prospective hire or someone on your team. We agree on the questions, format, and report scope before work begins.",
    path: "/employers/talent-assessments",
    action: "Explore talent assessments",
  },
  {
    title: "Secure Job Descriptions",
    copy: "Clarify the responsibilities and experience you need, then build or refine a job description that explains the role without exposing sensitive details.",
    path: "/employers/secure-job-descriptions",
    action: "Explore secure job descriptions",
  },
] as const;

export function RecruitingServices() {
  return (
    <section className="public-shell home-content-section" id="services">
      <div className="method-section content-panel">
        <SectionHeading
          title="Our Services Beyond Recruiting"
          copy="We also provide technical talent assessments for Cybersecurity roles and help employers develop secure job descriptions that explain the work while keeping sensitive details out of public view."
        />
        <div className="talent-capabilities">
          {homeCapabilities.map((item, index) => (
            <article key={item.title}>
              <span className="home-service-icon" aria-hidden="true">
                {index === 0 ? <CompassMark symbolOnly /> : <FileText strokeWidth={1.5} />}
              </span>
              <h2>{item.title}</h2>
              <p>{item.copy}</p>
              <Link className="text-link" to={item.path}>
                {item.action}
                <ChevronRight aria-hidden="true" size={16} />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
